import { ApiResponse} from "@/OneLiners";
import { api } from "@/Shared/Lib";
import { AppEnum, AppEnumsRecord } from "@/Shared/Types";


export class AppService {
    static fetchEnums = async (): Promise<ApiResponse<AppEnumsRecord>> => {
        const { data } = await api.get<ApiResponse<AppEnumsRecord>>(`/enums`);
        return data;
    };

    static fetchI18n = async (lang : string, isOnline : boolean): Promise<ApiResponse<Record<string, string>>> => {
        const i18nEndpoint = isOnline ? '/i18n/domains' : '/i18n/app'
        const { data } = await api.get<ApiResponse<Record<string, string>>>(i18nEndpoint + '/?lang=' + lang);
        return data; 
    };
}